import { Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { Auth0AuthContext } from './AuthContext/Auth0AuthContext';
import { LocalAuthContext } from './AuthContext/LocalAuthContext';

export function AuthProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  const domain = import.meta.env.VITE_REACT_APP_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_REACT_APP_AUTH0_CLIENT_ID;
  const audience = import.meta.env.VITE_REACT_APP_AUTH0_AUDIENCE;
  const scope = import.meta.env.VITE_REACT_APP_AUTH0_SCOPE;
  const redirectUri = window.location.origin;
  const testing = import.meta.env.VITE_REACT_APP_TESTING === 'true';

  if (testing) {
    return <LocalAuthContext>{children}</LocalAuthContext>;
  }

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        scope: scope,
        redirect_uri: redirectUri,
      }}
      useRefreshTokens={true}
      cacheLocation='localstorage'
      onRedirectCallback={onRedirectCallback}
    >
      <Auth0AuthContext>{children}</Auth0AuthContext>
    </Auth0Provider>
  );
}

export default AuthProvider;
